import { render, staticRenderFns } from "./sumLeave.vue?vue&type=template&id=55075eea&scoped=true&"
import script from "./sumLeave.vue?vue&type=script&lang=js&"
export * from "./sumLeave.vue?vue&type=script&lang=js&"
import style0 from "./sumLeave.vue?vue&type=style&index=0&id=55075eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55075eea",
  null
  
)

export default component.exports